/** Replaces positional `{0}`, `{1}`, … placeholders with the given values. */
export const interpolate = (template: string, ...values: (string | number | undefined)[]): string =>
    values.reduce<string>((result, value, index) => result.replace(`{${index}}`, String(value ?? '')), template);
